export default class PdfName extends String {
  constructor(value: string) {
    super(value);
  }

  toString(): string {
    return `/${this.valueOf()}`;
  }
}
